import * as React from 'react';
import { clsxm } from 'lib/clsxm';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

type MessageBoxProps = {
  children?: any;
  className?: string;
  icon: FontAwesomeIconProps['icon'];
  size?: 'sm' | 'md' | 'lg';
  title?: string;
  variant?: 'teal' | 'amber' | 'red' | 'green' | 'chocolate';
};

export const MessageBox = React.forwardRef<HTMLDivElement, MessageBoxProps>(
  (
    {
      className,
      variant = 'teal',
      icon,
      title,
      size = 'md',
      children,
      ...rest
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        {...rest}
        className={clsxm(
          'mx-auto my-6 flex w-full max-w-xl flex-wrap items-center gap-4 p-4 sm:flex-nowrap sm:rounded',
          // #region  //*=========== Variants ===========
          [
            variant === 'amber' && ['bg-amber-100 text-amber-600'],
            variant === 'teal' && ['bg-teal-100 text-teal-600'],
            variant === 'red' && ['bg-red-100 text-red-600'],
            variant === 'green' && ['bg-green-100 text-green-600'],
            variant === 'chocolate' && ['bg-chocolate-100 text-chocolate-600'],
          ],
          // #endregion  //*======== Variants ===========
          className
        )}
      >
        <FontAwesomeIcon
          icon={icon}
          className={clsx('mx-auto inline-block flex-shrink-0', [
            size === 'sm' && ['h-8 w-8'],
            size === 'md' && ['h-12 w-12'],
          ])}
        />
        <div className='w-full'>
          {title && (
            <span
              className={clsx(
                'mb-3 text-center font-bold sm:mb-0 sm:text-left',
                [size === 'sm' && ['text-lg'], size === 'md' && ['text-xl']]
              )}
            >
              {title}
            </span>
          )}
          <div className={clsx([size === 'sm' && ['text-sm']])}>{children}</div>
        </div>
      </div>
    );
  }
);
